import React from 'react';

// PNG
import EV from '../media/icons/png/EV.png';
import Battery from '../media/icons/png/Battery.png';
import EK from '../media/icons/png/EK.png';
import Remote from '../media/icons/png/Remote.png';
import SW from '../media/icons/png/SW.png';
import VCU from '../media/icons/png/VCU.png';

function AboutOurWork() {
  const feature = [
    {
      icon: EV,
      title: 'EV Powertrain',
      text: `Realizzazione di Powertrain custom nell'ambito della mobilità elettrica, lavorando su sistema ad alta tensione e con un alto grado di ingegnerizzazione`,
    },
    {
      icon: Battery,
      title: 'Battery & BMS',
      text: `Sviluppo del BMS Custom e implementazione di pacchi batteria su misura, offrendo la massima sicurezza e affidabilità in diverse applicazioni dell'ambito automotive e nautico.`,
    },
    {
      icon: VCU,
      title: 'VCU',
      text: `Vehicle Control Unit proprietaria: Conforme agli standard automotive, con elevati input/output e funzionalità CAN standard di comunicazione: J1939 ISO11898`,
    },
    {
      icon: SW,
      title: 'SW & FW',
      text: `Sviluppo Software e Firmware dedicato per governare al meglio i componenti dell'intero powertrain`,
    },
    {
      icon: Remote,
      title: 'Remote Diagnostic',
      text: `I dati di funzionamento del sistema sono raccolti ed elaborati da specifici algoritmi, basati su tecnologie di Intelligenza Artificiale, che potranno predirre eventuali guasti`,
    },
    {
      icon: EK,
      title: 'Electrification Knowledge',
      text: `Competenza ingegneristica legata allo  sviluppo di veicoli elettrificati di stampo innovativo. Seguendo il cliente dall'idea fino al prodotto finito`,
    },
  ];

  return (
    <div>
      <section class="bg-gray-900 text-white">
        <div class="container mx-auto px-10 py-16 sm:px-6 lg:px-8">
          <div class="max-w-xl">
            <h2 class="text-3xl font-bold sm:text-4xl">
              I nostri punti di forza
            </h2>
          </div>

          <div className="grid grid-cols-1 gap-8 mt-8 md:mt-16 md:grid-cols-2 md:gap-12 lg:grid-cols-3">
            {feature &&
              feature.map((punto, id) => (
                <div key={id} className="flex items-start ">
                  <span className="flex-shrink-0 p-4 bg-gray-800 rounded-lg">
                    <img src={punto.icon} className="w-12" />
                  </span>
                  <div class="ml-4">
                    <h2 class="text-lg font-bold">{punto.title}</h2>
                    <p class="mt-1 text-sm text-gray-300">{punto.text}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutOurWork;
